import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "./ui/tooltip";
import { usePreferences } from "../context/PreferencesContext";

// Premium hover card for NERC requirement/part numbers: bold the label, show the full
// requirement text below (scrollable when long) so no one has to decode a bare number.
// Respects the per-user "Requirement hover tooltips" preference (Account → Preferences).
export const RequirementHover = ({ label, text, children, side = "right" }) => {
  const { prefs } = usePreferences();
  if (!prefs.hoverTooltips) return children;
  return (
  <TooltipProvider>
    <Tooltip delayDuration={150}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={side} align="start" className="max-w-md bg-popover text-popover-foreground border border-border shadow-lg p-3 rounded-none z-50">
        <div className="font-mono font-bold text-xs mb-1">{label}</div>
        <div className="text-xs leading-relaxed max-h-56 overflow-y-auto whitespace-pre-wrap">{(text || "").trim() || "No requirement text available."}</div>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
  );
};
